<template>
    <div class="container">
        <div class="container-proposal-maps">
            <div>
                <span class="title">Integração ERP - </span>
                <span class="title-integration">Informakon </span>
                <span class="title">- Mapear campos para Proposta </span>
            </div>

            <div class="body-availability">
                <div class="body-availability-header">
                    <div class="button-exit">
                        <ui-button design="sm line" @click="returnIntegrationErp">
                            <em class="far fa-chevron-left" />
                        </ui-button>
                    </div>
                    <div class="body-availability-header-title"><span>Mapear Campos para envio da Proposta</span></div>
                    <div class="body-availability-header-subtitle"><span>Faça o mapeamento para os campos que serão enviados para a proposta.</span></div>
                </div>

                <div class="hr" />

                <div class="body-availability-content">
                    <div class="body-availability-content-select">
                        <div class="fields-facilita-erp">
                            <ui-select-v2
                                v-model="form.data.depara_type"
                                :data="dePara"
                                label="Tipo de_para:"
                                placeholder="Selecione"
                                return-value="value"
                                required/>
                            <ui-select-v2
                                v-model="fieldFacComputed"
                                :data="campoFacilita"
                                label="Campo Facilita:"
                                placeholder="Selecione"
								group-by="group"
								required/>
                            <ui-select-v2
                                v-model="form.data.field_erp"
                                :data="campoERP"
                                label="Campo ERP:"
                                placeholder="Selecione"
                                return-value="value"
                                group-by="group"
								required/>
                        </div>
                        <ui-select-v2
                            v-model="form.data.proposal_data_type"
                            :data="tipoCliente"
                            label="Tipo:"
                            placeholder="Selecione"
                            return-value="value"
                            @input="chooseProponent"
							required/>
                        <ui-select-v2
                            v-if="tipoClienteSelecionado === 'bidder' || tipoClienteSelecionado === 'bidder-clienteMutuario' ||  tipoClienteSelecionado === 'bidder-clienteContatos'"
                            v-model="form.data.bidder_number"
                            :data="tipoProponente"
                            label="Tipo Proponente:"
                            placeholder="Selecione"
                            return-value="value"
							required/>
                    </div>

                    <div class="body-availability-content-add-fields">
                        <span class="body-availability-content-add-fields-proposal" @click="add">
                            <ui-load-indicator v-if="load" bg-color="#e7e9f4" color="#69D296" :h="20" :stroke="8"/>
                            + Adicionar campo mapeado
                        </span>
                    </div>
                </div>

                <div class="hr" />

                <div class="container-proposal-table">
                    <proposal-maps-fields-table :contents="data"/>
                </div>

                <div class="container-proposal-footer">
                    <div class="container-proposal-footer-button">
                        <ui-button
                            type="button"
                            design="success lg mw-150"
							:disabled="!canSubmit"
                            @click="returnIntegrationErp">
                            Finalizar
                        </ui-button>
                    </div>
                </div>
            </div>

            <div class="container-proposal-links">
                <div class="links">
                    <router-link to="integracoes">
                        <div class="links-integrations-enterprises">Listar Integrações ERP</div>
                    </router-link>

                    <div class="links-add-line-vertical" />

                    <router-link to="empreendimentos">
                        <div class="links-integrations-enterprises">Empreendimentos Integrados</div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2 } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import proposalMapsFieldsTable from './components/proposal-maps-fields-table'

	import { fieldGroupHasField, s3Filesystem, erp, funnel } from '@/services/axios'

	import { utilMixin } from '@/mixins'

	const lodash = require("lodash")

	const defaultDataTable = [
		{
			name_facilita: '',
			fields_erp: '',
			type: '',
		}
	]

	const defaultFormData = (integration_erp_id) => ({
		depara_type: '',
		integration_erp_id,
		regex: null,
		label: null,
		field_fac: null,
		field_erp: null,
		pattern: '',
		regex_type: null,
		proposal_data_type: null,
		bidder_number: null,
		position: null,
		field_id: null
	})

export default {
	components: {
		uiButton,
		uiSelectV2,
		proposalMapsFieldsTable,
		uiLoadIndicator
	},

	mixins: [utilMixin],

	props: {
		id: {
			type: [Number,String],
			required: false,
			default: 0,
		}
	},

	data(){
		return{
			data: [],
			proposalMapsFields: null,
			form: {
				data: { ...defaultFormData(this.id) },
				fields: {
					depara_type: {
						required: true,
						disabled: false
					},
					label: {
						required: true,
						disabled: false
					},
					field_fac: {
						required: true,
						disabled: false
					},
					field_erp: {
						required: true,
						disabled: false
					},
					proposal_data_type: {
						required: true,
						disabled: false
					},
					bidder_number: {
						required: true,
						disabled: false
					}		
				}
			},
			dePara:[
				{
					label: 'Proposta',
					value: 'proposal'
				},
			],
			campoFacilita:[],
			campoERP:[],
			tipoCliente: [],
			tipoProponente: [
				{
					label: '1º Proponente',
					value: '1'
				},
				{
					label: '2º Proponente',
					value: '2'
				},
				{
					label: '3º Proponente',
					value: '3'
				},
				{
					label: '4º Proponente',
					value: '4'
				},
				{
					label: '5º Proponente',
					value: '5'
				},
				{
					label: '6º Proponente',
					value: '6'
				},
				{
					label: '7º Proponente',
					value: '7'
				},
				{
					label: '8º Proponente',
					value: '8'
				},
				{
					label: '9º Proponente',
					value: '9'
				},
				{
					label: '10º Proponente',
					value: '10'
				},
			],
			tipoClienteSelecionado: null,
			getFieldsInformakonERP: null,
			load: false,
			campoFacilitaRequired: [],
			uniqueIdCounter: 1

		}
	},

	computed: {
		fieldFacComputed: {
			get() {
				return this.form.data.field_fac
					? { label: this.form.data.label, value: this.form.data.field_fac, id: this.form.data.field_id }
					: null
			},
			set(value) {
				this.form.data.field_fac = value.value
				this.form.data.label = value.label
				this.form.data.field_id = value.id
			}
		},
		canSubmit() {
			if (this.validateForm().valid || this.data.length) {
				for (const label of this.campoFacilitaRequired) {
					if (!this.data.some(item => item.field_fac === label.label)) {
						return false 
					}
				}
			}
			return true
		}
	},

	created() {
		this.$root.$on('modal-msg-delete-erp-proposal-fields-response', (payload) => {
			this.$toastr.s(payload.msg)
			this.getFieldsMapped()
		})
	},

	mounted() {
		this.getProposalMapsFields()
		this.getERPFields()
		this.getFieldsMapped()
		this.getProposalDataType()
	},

	beforeDestroy() {
		this.$root.$off('modal-msg-delete-delete-erp-proposal-fields-response')
	},

	methods: {
		returnIntegrationErp(){
			this.$router.push({name: 'marketing.integrations.erp.integrations'})
		},
		async getProposalMapsFields() {
			try {
				const response1 = await funnel.getFieldGroups()
				this.proposalMapsFields = response1.data

				this.campoFacilita = Object.values(this.proposalMapsFields)
				.filter((item) =>
					item.fields.some(
					(field) =>
						field.options &&
						field.options.informakon &&
						field.options.informakon !== 'integration' &&
						field.options.informakon !== 'unit' &&
						field.options.informakon !== 'product'
					)
				)
				.flatMap((item) =>
					item.fields
					.filter(
						(field) =>
						field.options &&
						field.options.informakon &&
						field.options.informakon !== 'integration' &&
						field.options.informakon !== 'unit' &&
						field.options.informakon !== 'product'
					)
					.map((field) => ({
						group: item.name,
						id: field.id,
						label: field.name,
						value: field.name,
						required: field.required,
					}))
				)

				const response2 = await fieldGroupHasField.getFields()
				const filteredFields = response2.data.filter(
				(field) =>
					field.options &&
					(field.options.informakon === 'Usuário' ||
					field.options.informakon === 'Usuário Corretor Contatos')
				)

				const concatenatedFields = filteredFields.map((field) => ({
				group: field.options.informakon,
				id: field.id,
				label: field.name,
				value: field.name,
				required: field.required,
				}))

				this.campoFacilita = this.campoFacilita.concat(concatenatedFields)

				this.campoFacilitaRequired = this.campoFacilita.filter((res) => res.required)

			} catch (error) {
				console.error(error)
			}
		},
		async getERPFields() {
			try {
				const response = await s3Filesystem.getERPFieldsS3()
				let campoERP = response.data
				.filter(item => item.group)
				.map(item => {
					item.fields.map(field => (
						this.campoERP.push({
						id: this.uniqueIdCounter++,	
						group: item.label,
						label: field.label, 
						value:field.erp_field})
						))
				})
				
			} catch (error) {
				console.error(error)
			}
		},
		chooseProponent(value) {
			this.tipoClienteSelecionado = value
		},
		add() {
			this.load = true
			erp.createV2('fields-mapping', this.form.data)
				.then(response => {
					this.$toastr.s(response.data.msg)
					this.form.data = { ...defaultFormData(this.id) }
					this.isAdvanced = false
					this.getFieldsMapped()
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				})
				.finally(() => {
					this.load = false
				})
		},
		async getFieldsMapped() {
			await erp.getMapsFields()
				.then((response) => {
						this.data = Object.values(response.data.data)
							.filter(field => field.depara_type === 'proposal' && field.integration_erp_id == this.id)
					})
					.catch((error) => {
						console.error(error)
					})
		},
		validateRequired(field, dataField = '') {
			if (!Object.prototype.hasOwnProperty.call(this.form.fields, field)) {
				throw new Error(`Falha ao validar o campo ${field}. Este campo não existe!`)
			}
			dataField = dataField || field
			const required = this.form.fields[field].required
			const validation = this.$mx_hasValue(lodash.get(this.form.data, dataField))

			return (required && validation) || !required
		},
		/**
		* Valida os campos do formulário de acordo com diferentes conjuntos de regras
		*/
		validateForm() {
			let valid = true
			let message = '<ul>'
			try {
				if (!this.validateRequired('depara_type')) {
					valid = false
					message += '<li>É necessário definir o tipo de mapeamento.</li>'
				}

				if (!this.validateRequired('label')) {
					valid = false
					message += '<li>É necessário definir o label do campo mapeado.</li>'
				}

				if (!this.validateRequired('field_fac')) {
					valid = false
					message += '<li>É necessário selecionar um campo Facilita.</li>'
				}

				if (!this.validateRequired('field_erp')) {
					valid = false
					message += '<li>É necessário selecionar um campo ERP.</li>'
				}

				if (!this.validateRequired('proposal_data_type')) {
					valid = false
					message += '<li>É necessário selecionar o tipo de cliente.</li>'
				}

				if (this.tipoClienteSelecionado === 'bidder') {
					if (!this.validateRequired('bidder_number')) {
						valid = false
						message += '<li>É necessário definir o tipo do proponente.</li>'
					}
				}

			} catch (e) {
				this.$toastr.e(e)
				valid = false
			}
			message += '</ul>'

				return { valid, message }
		},
		async getProposalDataType() {
			await s3Filesystem.getProposalType()
				.then((response) => {
					this.tipoCliente = response.data.informakon
					})
				.catch((error) => {
					console.error(error)
				})
		}
	}

}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>